import { useAuthStore } from "@src/stores/auth";
import { useChatSessionStore } from "@src/stores/chatSession";
import { db } from "@src/services/db";
import "@src/services/echo";

type SessionFixedEventPayload = {
    id: number;
    is_fixed: boolean;
    updated_at?: string;
};

export const FixedSessionListener = () => {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets
        .private(`user.${userId}`)
        .listen(".SessionFixedEvent", async (event: SessionFixedEventPayload) => {
            try {
                if (!event?.id) return;

                const sid = Number(event.id);
                const fixed = event.is_fixed;

                //update no IndexedDB
                await db.sessions.update(sid, {
                    is_fixed: fixed,
                    updated_at: Date.now(),
                } as any);

                // se estiver aberta, atualiza também
                if (Number((sessionStore.selectedSession as any)?.id) === sid) {
                    (sessionStore.selectedSession as any).is_fixed = fixed;
                }
            } catch (e) {
                console.error("❌ erro no listener SessionFixedEvent", e);
            }
        });
};